<template>

    <transition
        name="fade"
        mode="out-in"
        appear>

        <div class="exposures-carousel" id="exposures-carousel">

            <transition
                    name="fade"
                    mode="out-in"
                    appear>

                <div class="carousel-items">

                    <div class="carousel-item" @click="getExposure(exposure.exposure_slug)" v-for="(exposure, index) in filteredExposures">

                        <div class="inner">

                            <div class="image">
                                <img :src="exposure.mobile.gridImageX1"
                                     :srcset="(exposure.mobile.gridImageX1 + ' 1x,' + exposure.mobile.gridImageX2 + ' 2x,' + exposure.mobile.gridImageX3 + ' 3x')"
                                     alt="" />
                            </div>
                            <h3 v-html="exposure.exposure_label"></h3>

                        </div>

                    </div>

                </div>

            </transition>

        </div>

    </transition>

</template>


<script>

    let vm = {};

    export default {

        name: 'exposures-carousel',

        props: {
            selectedSlug: {
                type: String,
                default: null
            }
        },

        components: {},

        data() {
            return {

            }
        },

        computed: {

            hasEntered() {
                return this.$dataStore.getters.getEnteredState;
            },

            exposures() {
                let _exposures = this.$dataStore.getters.getExposures;
                // alpha sort by label
                _exposures = _.sortBy(_exposures, ['exposure_label']);
                return _exposures;
            },

            filteredExposures() {
                return _.filter(vm.exposures, function(obj) {
                    return obj.exposure_slug !== vm.selectedSlug;
                });
            }

        },

        created() {
            vm = this;
        },

        mounted() {
            vm = this;

            /*setTimeout(function() {
                vm.initCarousel();
            }, 250);*/
        },

        methods:{

            initCarousel() {
                $('.exposures-carousel .carousel-items').slick({
                    infinite: false,
                    swipeToSlide: true,
                    slidesToShow: 3,
                    variableWidth: true
                });
            },

            getExposure(slug) {
                console.log('getExposure', slug);

                this.$eventBus.$emit('exposure:get', slug);

                $('html, body').animate({ scrollTop: 0 }, 600);
            },

            exposureClosed() {
                vm.selectedSlug = null;
                $('html, body').animate({ scrollTop: 0 }, 600);
                vm.animateGridItems(300);
            },

            /**
             * @method getCSSColorVariable
             * @description
             * @param color
             * @return {string}
             */
            getCSSColorVariable(color) {
                let _propVal = window.getComputedStyle(document.documentElement).getPropertyValue(color);

                if (!_propVal) {
                    let _color = color.replace('--', '$');
                    _propVal = window.appTheme.colors[_color];
                }

                //console.log('_propVal', _propVal);

                return _propVal;
            },

            /**
             * @method cssPropColor
             * @description
             */
            cssPropColor(colorProp) {
                if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                    return;
                } else {
                    return (window.appTheme.colors[colorProp]) ? window.appTheme.colors[colorProp] : false;
                }
            },

            isOdd(num) {
                return num % 2;
            }

        }

    }

</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/variables';

    .exposures-carousel {

        & .container {
            width: 100%;
            padding: 0 20px;
            overflow: hidden;
        }

        & .carousel-items {
            margin: 0 0 0 0;
            display: flex;
            overflow-y: hidden;
            overflow-x: scroll;
            -webkit-overflow-scrolling: touch;
            flex-flow: row nowrap;
        }

        & .carousel-item {
            width: 110px;
            margin: 0 0 0 0;
            padding: 0 10px;

            &:focus {
                outline: none !important;
            }

            &:first-of-type {
                 width: 128px;

                 & > .inner {
                     margin: 0 0 0 1.250rem;
                 }
             }

            &:last-of-type {
                width: 128px;

                & > .inner {
                    margin: 0 1.250rem 0 0;
                }
            }

            & > .inner {
                min-width: 90px;
            }

            & .image {
                line-height: 0;
                max-width: 90px;
                margin: 0 auto 1.250rem;

                & > img {
                    max-width: 100%;
                    height: auto;
                }
            }

            & h3 {
                font-family: $font-univers-cond;
                font-size: 0.688rem;
                color: rgba(76,76,76, 1.0);
                text-transform: uppercase;
                line-height: 1.250;
                margin: 0 auto;
                padding: 0 0 0 0;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// ExposuresCarousel.vue?f698545e